import * as React from "react";
import Portrait from "@ui-kit/identity/portrait";

export type BaseProps = Pick<
  React.ComponentProps<typeof Portrait>,
  "picture" | "editable" | "onClick" | "size" | "className"
>;

export interface IProps extends BaseProps {
  isActive?: boolean;
  isAccessible?: boolean;
}

const RadarlyPortraitProject = ({
  picture,
  isAccessible = true,
  isActive = true,
  editable,
  onClick,
  size,
  className,
}: IProps) => (
  <Portrait
    picture={picture}
    type="project"
    state={isAccessible ? (isActive ? undefined : "paused") : "blocked"}
    editable={editable}
    onClick={onClick}
    size={size}
    className={className}
    displayShadow
  />
);

export default RadarlyPortraitProject;
